import { render, staticRenderFns } from "./ProductMediaPickerModal.vue?vue&type=template&id=1737255c&"
import script from "./ProductMediaPickerModal.vue?vue&type=script&lang=js&"
export * from "./ProductMediaPickerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports